import React from 'react';
import Typography from '@material-ui/core/Typography';
import * as QuizData from '../components/LikertQuizData.js';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import RadioGroup from '@material-ui/core/RadioGroup';
import * as Fab from '../components/Fab';
import * as Progress from '../components/Progress';
import * as Radio from '../components/Radio';
import ContactForm from '../components/ContactForm';
import Demographics from '../components/Demographics';
import Header from '../components/Header';
import { useHistory } from 'react-router-dom';
import Grid from '@material-ui/core/Grid';

// URL for API
const URL = 'https://quiz5ll-server.herokuapp.com';
//const URL = 'http://localhost:8080';
//const URL = '';

function Quiz() {
    const [currentQuestion, setCurrentQuestion] = React.useState(0);
    const [progressValue, setProgressValue] = React.useState(0);
    const [questionsAnswered, setQuestionsAnswered] = React.useState(0);
    const [quizStarted, setQuizStarted] = React.useState(false);
    const [directReports, setDirectReports] = React.useState(null);
    const [role, setRole] = React.useState(null);
    const [aspiringManager, setAspiringManager] = React.useState(null);
    const [reportsTo, setReportsTo] = React.useState(null);
    const [orgSize, setOrgSize] = React.useState(null);
    const [firstName, setFirstName] = React.useState(null);
    const [email, setEmail] = React.useState(null);
    const [contactCompleted, setContactCompleted] = React.useState(false);
    const [demographicsCompleted, setDemographicsCompleted] = React.useState(false);  
    let history = useHistory();

    // submit answers
    const submitAnswers = () => {
        fetch(`${URL}/likert/result/save`, {
            method: 'post',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                statements: QuizData.statements,
                first_name: firstName,
                email: email,
                direct_reports: directReports,
                role,
                aspiring_manager: aspiringManager,
                reports_to: reportsTo,
                org_size: orgSize,
            })
        })
            .then(res => res.json())
            .then(
                (result) => {
                    console.log('RESULT', result);
                    const url = `/quiz/result/${result.result}`
                    history.push(url);
                    window.gtag('event', 'assessment_completed', {
                        eventCategory: 'assessment',
                        eventAction: 'completed'
                    });
                },
                (error) => {
                    console.log('ERROR', error);
                }
            )
    }
    // demographics completed
    const onDemographicsCompleted = () => {
        window.gtag('event', 'demographics_completed', {
            eventCategory: 'demographics',
            eventAction: 'completed'
        });
		setDemographicsCompleted(true);
    }

    // contact completed
    const onContactCompleted = () => {
        setContactCompleted(true)
        setQuizStarted(true);
        window.gtag('event', 'contact_completed', {
            eventCategory: 'contact',
            eventAction: 'completed'
		});
    }
    // previous question click
    const handlePrev = () => {
        if (currentQuestion !== 0) {
            if (currentQuestion === 30 && questionsAnswered === 30) {
                setCurrentQuestion(currentQuestion - 2);
            } else {
                setCurrentQuestion(currentQuestion - 1);
            }
        }
    };
    // handle answer selected event
    const answerSelected = event => {
        const value = parseInt(event.target.value);

        // bump questions answers / progress bar
        if (QuizData.statements[currentQuestion].selection === null) {
            setQuestionsAnswered(questionsAnswered + 1);
            setProgressValue(((questionsAnswered + 1) / 30) * 100);
        }

        // set selection
        QuizData.statements[currentQuestion].selection = parseInt(event.target.value);

        // if value is 0 set all values to zero, otherwise score primary or seconday
        if (value === 0) {
            QuizData.statements[currentQuestion].primary_score = 0;
            QuizData.statements[currentQuestion].secondary_score = 0;
        } else {
            if (event.target.name === QuizData.statements[currentQuestion].primary) {
                QuizData.statements[currentQuestion].primary_score = Math.abs(value);
            } else {
                QuizData.statements[currentQuestion].secondary_score = Math.abs(value);
            }
        }
        // bump current question
        if (currentQuestion < 29) {
            setCurrentQuestion(currentQuestion + 1);
        }
    }

    return (
        <>
            <Header />
            <div id="demographics" style={{ display: !demographicsCompleted ? 'block' : 'none' }}>
                <Demographics onCompleted={
                    onDemographicsCompleted} 
                    setRole={setRole}
                    setOrgSize={setOrgSize}
                    setReportsTo={setReportsTo}
                    setDirectReports={setDirectReports}
                    setAspiringManager={setAspiringManager}
                />
            </div>
            <div id="contact_info" style={{ display: demographicsCompleted && !contactCompleted ? 'block' : 'none' }}>
                <ContactForm onCompleted={onContactCompleted} setFirstName={setFirstName} setEmail={setEmail} />
            </div>
            <div id="quiz" style={{ display: quizStarted ? 'block' : 'none' }}>
                <div className="instructions">
                    <div className="container">
                        <Typography variant="h6">
                            <b>Instructions</b>
                        </Typography>
                        <Typography variant="subtitle1">
                            <b>Select the statement in each pairing which you most identify with</b>. You'll automatically be advanced to the next pairing after each selection. To change a response, use the "Previous/Next Pair" buttons. You are required to answer each pair before moving to the next.
                        </Typography>
                    </div>
                </div>
                <div className="container">
                    <Progress.BorderLinearProgress variant="determinate" value={progressValue} color="secondary" />
                    <Typography variant="body1" style={{ fontStyle: 'italic', marginTop: '20px' }}>
                        I appreciate it most when my leader or manager...
                    </Typography>
                    <div style={{ marginTop: '20px' }} className="statements">
                        {QuizData.statements.map((row, index) => {
                            if (index === 29) {
                                return (
                                    <div id={index} key={index} className={(currentQuestion >= 29 && questionsAnswered >= 29) ? 'fadeIn' : 'fadeOut'}>
                                        <Typography variant="h5" style={{ fontSize: '19px', marginBottom: '25px' }}>
                                            {row.statement}
                                        </Typography>
                                        <Grid container direction="row" >
                                            <RadioGroup onChange={answerSelected} row >
                                                <Grid item xs={12} sm={12}>
                                                    <Radio.Disagree3Radio name={row.secondary} value="-2.5" />
                                                    <Radio.Disagree2Radio name={row.secondary} value="-2" />
                                                    <Radio.Disagree1Radio name={row.secondary} value="-1.5" />
                                                    <Radio.NeutralRadio name="neutral" value="0" />
                                                    <Radio.Agree1Radio name={row.primary} value="1.5" />
                                                    <Radio.Agree2Radio name={row.primary} value="2" />
                                                    <Radio.Agree3Radio name={row.primary} value="2.5" />
                                                    <div style={{ clear: 'both' }} />
                                                    <Typography style={{ fontWeight: '500', fontSize: '13px', float: 'left' }}>
                                                        Disagree
                                                	</Typography>
                                                    <Typography style={{ fontWeight: '500', fontSize: '13px', float: 'right' }}>
                                                        Agree
                                                	</Typography>
                                                </Grid>
                                            </RadioGroup>
                                        </Grid>
                                    </div>
                                );
                            }
                            return (
                                <div id={index} key={index} className={currentQuestion === index ? 'fadeIn' : 'fadeOut'}>
                                    <Typography variant="h5" style={{ fontSize: '19px', marginBottom: '30px' }}>
                                        {row.statement}
                                    </Typography>
                                    <Grid container direction="row">
                                        <RadioGroup onChange={answerSelected}>
                                            <Grid item xs={12} sm={12}>
                                                <Radio.Disagree3Radio name={row.secondary} value="-2.5" />
                                                <Radio.Disagree2Radio name={row.secondary} value="-2" />
                                                <Radio.Disagree1Radio name={row.secondary} value="-1.5" />
                                                <Radio.NeutralRadio name="neutral" value="0" />
                                                <Radio.Agree1Radio name={row.primary} value="1.5" />
                                                <Radio.Agree2Radio name={row.primary} value="2" />
                                                <Radio.Agree3Radio name={row.primary} value="2.5" />
                                                <div style={{ clear: 'both' }}/>
                                                <Typography style={{ fontWeight: '500', fontSize: '13px', float: 'left' }}>
                                                    Disagree
                                                </Typography>
                                                <Typography style={{ fontWeight: '500', fontSize: '13px', float: 'right' }}>
                                                    Agree
                                                </Typography>
                                            </Grid>
                                        </RadioGroup>
                                    </Grid>
                                </div>
                            );
                        })
                        }
                    </div>
                    <div>
                        <Fab.BlueFab
                            style={{ marginTop: '20px' }}
                            variant="extended"
                            size="medium"
                            disabled={currentQuestion === 0}
                            onClick={handlePrev}
                        >
                            <ArrowBackIcon />
                            Previous
                        </Fab.BlueFab>
                        {currentQuestion >= 29 ?
                            (
                                <Fab.BlackFab
                                    style={{ marginTop: '20px', marginLeft: '20px' }}
                                    variant="extended"
                                    size="medium"
                                    onClick={submitAnswers}
                                    disabled={questionsAnswered === 29}
                                >
                                    Complete
                            </Fab.BlackFab>

                            ) : (
                                <Fab.BlueFab
                                    style={{ marginTop: '20px', marginLeft: '20px' }}
                                    variant="extended"
                                    size="medium"
                                    disabled={questionsAnswered === currentQuestion}
                                    onClick={answerSelected}
                                >
                                    Next
                                    <ArrowForwardIcon />
                                </Fab.BlueFab>
                            )
                        }
                    </div>
                </div>
            </div>
        </>
    );
}

export default Quiz;
